/**
 * A count with thousands separators: "12,045". One formatter for every count
 * badge, so the number on screen, its tooltip and its hidden label always
 * match. Built once, because Firefox and Safari construct a new formatter on
 * every `toLocaleString('en-US')` call.
 */
const COUNT_FORMAT = new Intl.NumberFormat('en-US');

export function formatCount(count: number): string {
    return COUNT_FORMAT.format(count);
}
